/**
 * Deutscher Textkatalog für das Commerce-Feature
 * (`@gamecodex/world-ui` → `features/commerce`).
 *
 * Die Schlüssel entsprechen den `t('commerce.*')`-Aufrufen in den React-Komponenten des Features.
 * Die Werte sind die deutschen Übersetzungen der ursprünglichen englischen Strings.
 */
export const commerceDe = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoTitle': 'Sichere dir deine Bibliothek',
  'commerce.dtrpg.seoDescription': 'Importiere deine DriveThruRPG-Bibliothek und sichere dir deine Grymwyrd-PDFs.',
  'commerce.dtrpg.heading': 'Sichere dir deine Bibliothek',
  'commerce.dtrpg.intro':
    'Grymwyrd auf DriveThruRPG gekauft oder die Kampagne unterstützt? Melde dich mit deiner Kauf-E-Mail an, um deine Bibliothek zu importieren und deine Exemplare zu sichern.',
  'commerce.dtrpg.sendLinkError': 'Wir konnten deinen Anmeldelink gerade nicht senden. Versuche es gleich noch einmal.',
  'commerce.dtrpg.checkInboxPrefix': 'Sieh in deinem Posteingang nach:',
  'commerce.dtrpg.checkInboxSuffix':
    'Wenn diese E-Mail Grymwyrd unterstützt oder gekauft hat, ist ein Anmeldelink unterwegs — klicke ihn an, um hierher zurückzukehren und deine Bibliothek zu sichern.',
  'commerce.dtrpg.linkAutoSignIn': 'Der Link meldet dich automatisch an — kein Passwort nötig.',
  'commerce.dtrpg.purchaseEmailLabel': 'Deine Kauf- / Unterstützer-E-Mail',
  'commerce.dtrpg.sendingLink': 'Link wird gesendet…',
  'commerce.dtrpg.emailLinkCta': 'Schick mir einen Anmeldelink per E-Mail',
  'commerce.dtrpg.signedInAs': 'Angemeldet als',
  'commerce.dtrpg.signOut': 'Abmelden',
  'commerce.dtrpg.dtrpgEmailLabel': 'DriveThruRPG-E-Mail',
  'commerce.dtrpg.dtrpgEmailOptional': '(optional — falls abweichend von oben)',
  'commerce.dtrpg.dtrpgEmailHelp': 'Damit gleichen wir deine DriveThruRPG-Käufe ab, wenn wir dir deine Bibliothek freischalten.',
  'commerce.dtrpg.libraryHeading': 'Deine Grymwyrd-Bibliothek',
  'commerce.dtrpg.noTitles': 'Es sind noch keine importierbaren Titel eingerichtet.',
  'commerce.dtrpg.claimNotInLibrary':
    'Dieser Titel ist noch nicht in deiner Bibliothek. Vergewissere dich, dass du die richtige Kauf-E-Mail verwendet hast.',
  'commerce.dtrpg.claimSessionExpired': 'Deine Sitzung ist abgelaufen — melde dich erneut an.',
  'commerce.dtrpg.claimError': 'Dieser Titel konnte gerade nicht gesichert werden. Bitte versuche es erneut.',
  'commerce.dtrpg.preparingCopy': 'Dein Exemplar wird vorbereitet…',
  'commerce.dtrpg.download': 'Herunterladen',
  'commerce.dtrpg.preparing': 'Wird vorbereitet…',
  'commerce.dtrpg.claiming': 'Wird gesichert…',
  'commerce.dtrpg.claim': 'Sichern',

  // PaywallPrompt.tsx
  'commerce.paywall.checkoutFailed': 'Die Kasse konnte nicht geöffnet werden. Bitte versuche es bald erneut.',
  'commerce.paywall.signInToPurchase': 'Melde dich an, um diesen Kauf abzuschließen.',
  'commerce.paywall.vaultSealed': 'Das Gewölbe des Händlers ist vorerst versiegelt — bitte versuche es bald erneut.',
  'commerce.paywall.signInToUnlock': 'Zum Freischalten anmelden',
  'commerce.paywall.comingSoonTitle': 'Dieser Kauf ist bald verfügbar',
  'commerce.paywall.priceComingSoon': '{price} — bald verfügbar',
  'commerce.paywall.comingSoon': 'Bald verfügbar',
  'commerce.paywall.openingVault': 'Das Gewölbe wird geöffnet…',
  'commerce.paywall.unlockPrice': 'Freischalten — {price}',
  'commerce.paywall.unlock': 'Freischalten',

  // MarketplacePage.tsx
  'commerce.marketplace.installSuccess': '„{name}“ auf deinem Tisch installiert.',
  'commerce.marketplace.installNotOwned': 'Dieses Pack besitzt du noch nicht — der Kauf von Packs ist bald möglich.',
  'commerce.marketplace.installHostOnly': 'Nur der Tisch-Host kann ein Pack installieren.',
  'commerce.marketplace.installError': 'Dieses Pack konnte nicht installiert werden. Bitte versuche es erneut.',
  'commerce.marketplace.installed': 'Installiert',
  'commerce.marketplace.installing': 'Wird installiert…',
  'commerce.marketplace.installOnTable': 'Auf Tisch installieren',
  'commerce.marketplace.seoTitle': 'Marktplatz — Packs',
  'commerce.marketplace.seoDescription':
    'Durchstöbere und installiere Content-Packs von Creators — Karten, Szenen, Handouts und Vorlagen — auf deinen Tischen.',
  'commerce.marketplace.eyebrow': 'Marktplatz',
  'commerce.marketplace.heading': 'Content-Packs',
  'commerce.marketplace.intro':
    'Karten, Szenen, Handouts und Schnellstart-Vorlagen — installiere sie mit einem Klick auf deinen Tischen.',
  'commerce.marketplace.installingOnto': 'Wird auf Tisch {tableId} installiert.',
  'commerce.marketplace.signInHeading': 'Melde dich an, um deine Packs zu sehen',
  'commerce.marketplace.signInBlurb': 'Der Pack-Katalog ist mit deinem Creator-Konto verknüpft.',
  'commerce.marketplace.signIn': 'Anmelden',
  'commerce.marketplace.loading': 'Deine Packs werden herbeigerufen…',
  'commerce.marketplace.noPacksHeading': 'Noch keine Packs',
  'commerce.marketplace.noPacksBlurb':
    'Du hast noch keine Packs veröffentlicht. Ein öffentlicher Marktplatz zum Durchstöbern der Packs anderer Creators ist bald verfügbar.',
  'commerce.marketplace.footer': 'Das Durchstöbern der Packs anderer Creators und bezahlte Packs sind in Arbeit.',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.perk1Title': 'Tische nur für Abonnenten',
  'commerce.subscriber.perk1Blurb': 'Nimm an Tischen Platz, die deine Lieblings-Hosts für Abonnenten reservieren.',
  'commerce.subscriber.perk2Title': 'Frühe & exklusive Inhalte',
  'commerce.subscriber.perk2Blurb': 'Erhalte Kampagnenkapitel, Szenen und Handouts vor allen anderen.',
  'commerce.subscriber.perk3Title': 'Abonnenten-Abzeichen',
  'commerce.subscriber.perk3Blurb': 'Ein Zeichen des Ansehens auf deinem Profil und am Tisch.',
  'commerce.subscriber.seoTitle': 'Abonnenten-Vorteile',
  'commerce.subscriber.seoDescription':
    'Werde Abonnent für exklusive Tische, frühe Inhalte und dein Abonnenten-Abzeichen.',
  'commerce.subscriber.heading': 'Werde Abonnent',
  'commerce.subscriber.intro':
    'Unterstütze die Hosts und Creators, die du liebst — und schalte die Vorteile frei, die sie ihrem inneren Zirkel vorbehalten.',
  'commerce.subscriber.activeHeading': 'Du bist Abonnent',
  'commerce.subscriber.activeBlurb':
    'Deine Vorteile sind aktiv. Halte Ausschau nach dem Abonnenten-Wappen an Tischen, denen du beitreten kannst.',
  'commerce.subscriber.findTable': 'Einen Abonnenten-Tisch finden',
  'commerce.subscriber.paywallTitle': 'Grymwyrd-Abonnent',
  'commerce.subscriber.paywallBlurb':
    'Schalte Tische nur für Abonnenten, frühe Inhalte und dein Abonnenten-Abzeichen frei.',
  'commerce.subscriber.paywallPrice': 'ab 5 $/Monat',

  // TicketCheckoutPage.tsx
  'commerce.ticket.checkoutFailed': 'Die Kasse konnte nicht geöffnet werden. Bitte versuche es bald erneut.',
  'commerce.ticket.signInToBuy': 'Melde dich an, um einen Platz an diesem Tisch zu kaufen.',
  'commerce.ticket.boxOfficeClosed': 'Die Ticketkasse ist vorerst geschlossen — bitte versuche es bald erneut.',
  'commerce.ticket.seoTitle': 'Einen Platz kaufen',
  'commerce.ticket.seoDescription': 'Reserviere deinen Platz an einem Tisch mit Eintritt.',
  'commerce.ticket.eyebrow': 'Tisch mit Eintritt',
  'commerce.ticket.heading': 'Reserviere deinen Platz',
  'commerce.ticket.loading': 'Der Tisch wird geladen…',
  'commerce.ticket.notFoundHeading': 'Tisch nicht gefunden',
  'commerce.ticket.notFoundBlurb': 'Dieser Tisch wurde vielleicht geschlossen, oder seine Türen wurden nie geöffnet.',
  'commerce.ticket.backToLobby': 'Zurück zur Lobby',
  'commerce.ticket.freeHeading': 'Der Beitritt zu diesem Tisch ist kostenlos',
  'commerce.ticket.freeBlurb': 'Kein Ticket nötig — zieh dir einen Stuhl heran.',
  'commerce.ticket.goToLobby': 'Zur Lobby',
  'commerce.ticket.untitledTable': 'Unbenannter Tisch',
  'commerce.ticket.seatPrice': 'Platzpreis',
  'commerce.ticket.spectatorsNote': 'Auch Zuschauer benötigen ein Ticket für diesen Tisch.',
  'commerce.ticket.paymentReceived': 'Zahlung erhalten — dein Platz ist reserviert. Geh zur Lobby, um ihn einzunehmen.',
  'commerce.ticket.signInToBuySeat': 'Anmelden, um einen Platz zu kaufen',
  'commerce.ticket.openingBoxOffice': 'Die Ticketkasse wird geöffnet…',
  'commerce.ticket.buySeatPrice': 'Platz kaufen — {price}',
  'commerce.ticket.comingSoonTitle': 'Ticketing ist bald verfügbar',
  'commerce.ticket.ticketingComingSoon': 'Ticketing bald verfügbar',
  'commerce.ticket.comingSoonFooter': 'Bezahlte Plätze sind fast bereit. Bitte vorerst den Host um eine kostenlose Einladung.',

  // TipGoalManagerPage.tsx
  'commerce.tip.errHostOnlyGoal': 'Nur der Tisch-Host kann Ziele verwalten.',
  'commerce.tip.errHostOnlyBounty': 'Nur der Tisch-Host kann Kopfgelder verwalten.',
  'commerce.tip.errMaxGoal': 'Du hast die maximale Anzahl an Zielen für diesen Tisch erreicht.',
  'commerce.tip.errMaxBounty': 'Du hast die maximale Anzahl an Kopfgeldern für diesen Tisch erreicht.',
  'commerce.tip.errMissingGoal': 'Diesem Ziel fehlen erforderliche Angaben.',
  'commerce.tip.errMissingBounty': 'Diesem Kopfgeld fehlen erforderliche Angaben.',
  'commerce.tip.errSignIn': 'Melde dich als Host an, um diesen Tisch zu verwalten.',
  'commerce.tip.errSaveFailedGoal': 'Das Ziel konnte nicht gespeichert werden. Bitte versuche es erneut.',
  'commerce.tip.errSaveFailedBounty': 'Das Kopfgeld konnte nicht gespeichert werden. Bitte versuche es erneut.',
  'commerce.tip.goalValidation': 'Füge eine Bezeichnung und ein positives Dollar-Ziel hinzu.',
  'commerce.tip.goalAdded': 'Ziel „{label}“ hinzugefügt.',
  'commerce.tip.goalLabelPlaceholder': 'Ziel-Bezeichnung (z. B. Den Boss beschwören)',
  'commerce.tip.targetPlaceholder': 'Zielbetrag $',
  'commerce.tip.cuePlaceholder': 'Signal bei Erreichen (z. B. Fanfare)',
  'commerce.tip.addGoal': 'Ziel hinzufügen',
  'commerce.tip.bountyValidation': 'Füge eine Bezeichnung, ein positives Ziel und einen Auslöser hinzu.',
  'commerce.tip.bountyAdded': 'Kopfgeld „{label}“ hinzugefügt.',
  'commerce.tip.bountyLabelPlaceholder': 'Kopfgeld-Bezeichnung (z. B. Nat 20 rettet die Gruppe)',
  'commerce.tip.triggerPlaceholder': 'Auslöser (z. B. eine natürliche 20)',
  'commerce.tip.addBounty': 'Kopfgeld hinzufügen',
  'commerce.tip.signInToManage': 'Melde dich an, um diesen Tisch zu verwalten.',
  'commerce.tip.bountyClaimed': 'Kopfgeld „{label}“ eingelöst.',
  'commerce.tip.seoTitle': 'Trinkgeld-Ziele & Kopfgelder',
  'commerce.tip.seoDescription': 'Lege Trinkgeld-Ziele und Kopfgelder für deinen Tisch fest.',
  'commerce.tip.backToLobby': 'Zurück zur Lobby',
  'commerce.tip.heading': 'Trinkgeld-Ziele & Kopfgelder',
  'commerce.tip.intro':
    'Lege Ziele und Kopfgelder für deinen Tisch fest. Wenn der Becher überläuft, ertönt das Signal für dein Publikum. Die Anzeige im Stream übernimmt dein Broadcast-Overlay.',
  'commerce.tip.loading': 'Das Hauptbuch wird gelesen…',
  'commerce.tip.loadErrorTitle': 'Das Hauptbuch konnte nicht geladen werden',
  'commerce.tip.raisedSoFar': 'Bisher gesammelt:',
  'commerce.tip.tipGoalsHeading': 'Trinkgeld-Ziele',
  'commerce.tip.noGoals': 'Noch keine Ziele — füge unten dein erstes hinzu.',
  'commerce.tip.reachedAria': 'erreicht',
  'commerce.tip.bountiesHeading': 'Kopfgelder',
  'commerce.tip.noBounties': 'Noch keine Kopfgelder — füge unten dein erstes hinzu.',
  'commerce.tip.whenLabel': '· wenn: {trigger}',
  'commerce.tip.claimed': 'Eingelöst',
  'commerce.tip.claimTitleReady': 'Dieses Kopfgeld als eingelöst markieren',
  'commerce.tip.claimTitleNotFunded': 'Noch nicht finanziert',
  'commerce.tip.claim': 'Einlösen',
}
